import styled, { css } from "styled-components";

interface IInheritedSettingsFieldProps {
  disabled?: boolean
}

/**
 * Inherited settings wrapper
 */
export const InheritedSettingsField = styled.div<IInheritedSettingsFieldProps>`
  ${({ theme, disabled }) => css`
    padding-bottom: ${theme.spacing.padding.lg};
    transition: opacity 0.3s ease-in-out;

    ${disabled && css`
      pointer-events: none;
      opacity: 0.5;
    `};
  `};
`;
